module.exports = __webpack_public_path__ + "static/media/bn_inspiration_logos.327028a2.png";